// Centralized copy for sender messaging UX
export const LIMIT_RESET_TEXT = 'The limit resets when the next calendar month starts (UTC).';

export type PolicyCode = 'email_disabled' | 'post_only' | 'friends_only' | 'blocked' | 'chat_limit' | 'message_limit' | 'direct_cooldown' | 'content_rejected' | 'recipient_not_approved';

export function titleFor(code: PolicyCode): string {
  switch (code) {
    case 'email_disabled': return 'This user is not accepting email contacts.';
    case 'post_only': return 'This user accepts messages only as replies to their posts.';
    case 'friends_only': return 'This user only accepts messages from friends.';
    case 'blocked': return 'Messaging is blocked.';
    case 'chat_limit': return 'Monthly chat limit reached.';
    case 'message_limit': return 'Monthly message limit reached.';
    case 'direct_cooldown': return 'Please wait before sending another email.';
    case 'content_rejected': return 'Message rejected by filters.';
    case 'recipient_not_approved': return "This profile is still being reviewed.";
    default: return 'Action required';
  }
}

export function descriptionFor(code: PolicyCode, extra?: { hours?: number }): string {
  switch (code) {
    case 'email_disabled': return 'Try messaging via chat or check back later.';
    case 'post_only': return 'Open their profile or reply directly from a post.';
    case 'friends_only': return 'Open their profile to send a friend request.';
    case 'blocked': return 'You cannot exchange messages with this user.';
    // No plan sales copy (FE11). Both caps count from the first of the UTC
    // calendar month: PlanUsageService.MonthStartUtc for chat, and the
    // monthStart in ContactController.GetContactPolicyAsync for the form.
    case 'chat_limit': return LIMIT_RESET_TEXT;
    case 'message_limit': return LIMIT_RESET_TEXT;
    case 'direct_cooldown': return `Try again in about ${Math.ceil(Number(extra?.hours || 0))} hour(s).`;
    case 'content_rejected': return 'Please remove prohibited content and try again.';
    case 'recipient_not_approved': return "They can't receive messages until verification is complete. Please check back later.";
    default: return '';
  }
}

